module.exports = __webpack_public_path__ + "static/media/Kindred.37b37df9.png";